import React from 'react'
import { Link } from 'react-router-dom'
import { auth } from './firebase'
import './Header.css'
import logo from './img/mycart_logo.png'
import { useStateValue } from './StateProvider'
/* import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'; */
/* import SearchIcon from '@material-ui/icons/Search'; */



function Header() {
  const [{ basket, user }, dispatch]= useStateValue();

  const handleAuthenticaton = () => {
    if (user) {
      auth.signOut();
    }
  }

    return (
        <div className='header'>
          <Link to="/">
          <img className="header__logo" alt="mycart_logo" src={logo}/>
          </Link> 

         <div className="header__search">
        <input className="header__searchInput" type="text" />
        {/* <i class="bi bi-search header__searchIcon"></i> */}
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search header__searchIcon" viewBox="0 0 16 16">
  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
</svg>
        {/* <SearchIcon className="header__searchIcon" type="text" /> */}
      </div>

        <div className="header__nav">
     <Link to={!user && '/login'}>
      <div onClick={handleAuthenticaton} className="header__option">
      <span className="header__optionLineOne">Hello {!user ? 'Guest' : user.email}</span>
            <span className="header__optionLineTwo">{user ? 'Sign Out' : 'Sign In'}</span>
      </div>
      </Link>

      <Link to='/Orders'>
<div className="header__option">
  

<span className="header__optionLineOne"> Returns</span>
  <span className="header__optionLineTwo"> orders</span>
</div>
</Link>

<Link to= '/Service'>
<div className="header__option">
<span className="header__optionLineOne"> Mycart </span>
  <span className="header__optionLineTwo">Services</span>
</div>
</Link>
<Link to= '/Feedback'>
<div className="header__option">
<span className="header__optionLineOne">Product</span>
  <span className="header__optionLineTwo">Feedback</span>
</div>
</Link>



<Link to="/checkout">
<div className="header__optionBasket">
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cart-check" viewBox="0 0 16 16">
  <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"/>
  <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
</svg>
<span className="header__optionLineTwo header__basketCount">
              {basket?.length}
            </span>
          
            </div>
</Link>


</div>
     </div>
       
    )
}

export default Header
